import React from "react";
import NameMasterPage from "./NameMasterPage";

export default function DepartmentMaster() {
  return (
    <NameMasterPage
      title="Department Master"
      subtitle="Used in the Department dropdown across the system."
      apiBase="/departments"
      templateName="department_template.xlsx"
      testidPrefix="department"
    />
  );
}
